import { useState, useEffect } from 'react';

export const useAsyncAutocomplete = (fetchFn, minLength = 3) => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOptions = async () => {
      if (inputValue.length >= minLength) {
        setLoading(true);
        const result = await fetchFn(inputValue);
        setOptions(result || []);
        setLoading(false);
      } else {
        setOptions([]);
      }
    };

    const timeout = setTimeout(fetchOptions, 300); // debounce
    return () => clearTimeout(timeout);
  }, [inputValue, fetchFn, minLength]);

  return { inputValue, setInputValue, options, loading };
};
